import {
  READ_STATUS_MODEL_LIST,
  READ_STATUS_MODEL_LIST_SUCCEEDED,
  READ_STATUS_MODEL_LIST_FAILED,
} from "./types"

export const readStatusModel = config => {
  return { type: READ_STATUS_MODEL_LIST, config }
}

export const readStatusModelSuccess = config => {
  return { type: READ_STATUS_MODEL_LIST_SUCCEEDED, config }
}

export const readStatusModelError = (action, error) => {
  return { type: READ_STATUS_MODEL_LIST_FAILED, action, error }
}
